import { MetadataTypeEnum, metadataTypeEnumToJSON } from "build-ts/enums";
import { Header } from "build-ts/metadata";
import showToast from "hooks/useCustomToast";

/**
 * Updates the name and description in the header of given metadata.
 * 
 * @param id - The ID of the metadata object
 * @param name - The new name for the metadata
 * @param description - The new description for the metadata
 * @param type - The type of metadata (e.g., LOGICAL_COLUMN, METRIC, ANALYST, etc.)
 * @returns The updated metadata header or null if the update fails
 * @throws {Error} Throws an error if the request fails
 */
export const updateHeader = async (
	id: string,
	name: string,
	description: string,
	type: MetadataTypeEnum
): Promise<Header | null> => {
	try {
		const queryParams = new URLSearchParams({
			id: id,
			type: metadataTypeEnumToJSON(type),
			name: name,
			description: description,
		});

		const response = await fetch(
			`${process.env.REACT_APP_UPDATE_METADATA_HEADER}?${queryParams}`,
			{
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
				},
				credentials: "include",
			}
		);

		if (!response.ok) {
			showToast("Failed to update metadata header", "", "error");
			return null;
		}

		const data = await response.json();
		showToast("Metadata header updated successfully", "", "success");
		return Header.fromJSON(data);
	} catch (error: any) {
		showToast(
			"Error updating metadata header",
			error?.message || "Unknown error occurred",
			"error"
		);
		return null;
	}
};